import { render, staticRenderFns } from "./plus-line.vue?vue&type=template&id=74130272&"
import script from "./plus-line.vue?vue&type=script&lang=js&"
export * from "./plus-line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74130272')) {
      api.createRecord('74130272', component.options)
    } else {
      api.reload('74130272', component.options)
    }
    module.hot.accept("./plus-line.vue?vue&type=template&id=74130272&", function () {
      api.rerender('74130272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/plus-line.vue"
export default component.exports